import React from "react";
import { Headphones } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="footer"
      className="border-t border-zinc-200 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-[#002FA7] text-white">
            <Headphones className="h-4 w-4" />
          </span>
          <span className="font-serif text-xl font-bold text-zinc-950">
            AudioFlip
          </span>
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
          © {new Date().getFullYear()} AudioFlip · {t("footer.tagline")}
        </p>
        <div className="flex gap-6 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
          <a href="#" className="hover:text-[#002FA7] transition-colors duration-200">
            {t("footer.privacy")}
          </a>
          <a href="#" className="hover:text-[#002FA7] transition-colors duration-200">
            {t("footer.terms")}
          </a>
          <a href="#" className="hover:text-[#002FA7] transition-colors duration-200">
            {t("footer.contact")}
          </a>
        </div>
      </div>
    </footer>
  );
}
